import { reactify } from '@zeiss/zui-react';
export const ZuiIconEwiEwiColoredDarkWarningTriangle = reactify('zui-icon-ewi-ewi-colored-dark-warning-triangle');
